export default "__VITE_ASSET__5353329f__"